import React, { useContext, useState } from 'react';
import { Context } from '../../Context/Context';
import './Checkout.css';

const Checkout = () => {
  const { all_products, cartItems } = useContext(Context);
  
  const [formData, setFormData] = useState({
    fullName: '', email: '', phone: '', streetAddress: '', apartment: '', city: '', state: '', zip: ''
  });
  const [delivery, setDelivery] = useState('by hand');

  const handleChange = (e) => setFormData({...formData, [e.target.name]: e.target.value});

  let baseTotal = 0;
  const cartEntries = Object.entries(cartItems || {}).filter(([key, qty]) => qty > 0);
  
  cartEntries.forEach(([key, qty]) => {
    const [idStr, size] = key.split('_');
    const id = Number(idStr);
    const product = all_products.find((p) => p.id === id);
    if (product) {
      const price = Number(product.price[size].replace('$', ''));
      baseTotal += price * qty;
    }
  });

  const finalTotal = delivery === 'by mail' ? baseTotal + 1.00 : baseTotal;

  const itemsString = cartEntries.map(([key, qty]) => {
    const [idStr, size] = key.split('_');
    const product = all_products.find((p) => p.id === Number(idStr));
    return product ? `${product.name} (${size}) x${qty}` : '';
  }).join(' | ');

  const handleSubmit = (e) => {
    if (cartEntries.length === 0) {
      e.preventDefault();
      alert("Your cart is empty!");
    }
  };

  return (
    <div className='checkout-container'>
      <h1>Checkout</h1>
      <form action="https://api.sheetmonkey.io/form/6ZBG6YoCavBh3ko8VrWUP5" method="POST" encType="multipart/form-data" className='checkout-form' onSubmit={handleSubmit}>
        <input type="hidden" name="items" value={itemsString} />
        <input type="hidden" name="total" value={`$${finalTotal.toFixed(2)}`} />
        
        <div className='form-group'>
          <input type="text" name="fullName" placeholder="Full Name" required onChange={handleChange} />
          <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
        </div>
        <div className='form-group'>
          <input type="email" name="email" placeholder="Email" required onChange={handleChange} />
        </div>
        <div className='form-group'>
          <input type="text" name="streetAddress" placeholder="Street Address" required onChange={handleChange} />
          <input type="text" name="apartment" placeholder="Apartment (Optional)" onChange={handleChange} />
        </div>
        <div className='form-group three-col'>
          <input type="text" name="city" placeholder="City" required onChange={handleChange} />
          <input type="text" name="state" placeholder="State" required onChange={handleChange} />
          <input type="text" name="zip" placeholder="Zip Code" required onChange={handleChange} />
        </div>

        <div className='delivery-options'>
          <h3>How do you want your stickers delivered?</h3>
          <label>
            <input type="radio" name="delivery" value="by hand" checked={delivery === 'by hand'} onChange={(e) => setDelivery(e.target.value)} />
            By hand (check my current location)
          </label>
          <label>
            <input type="radio" name="delivery" value="by mail" checked={delivery === 'by mail'} onChange={(e) => setDelivery(e.target.value)} />
            By mail (+$1.00)
          </label>
        </div>

        <div className='order-summary'>
          <h2>Total Cost: ${finalTotal.toFixed(2)}</h2>
          <button type="submit" className='place-order-btn'>Place Order</button>
        </div>
      </form>
    </div>
  );
};
export default Checkout;
